<template>
	<div class="file-attachments-preview" v-if="attachments.length > 0">
		<div class="attachments-container">
			<div v-for="(attachment, index) in attachments" :key="index" class="attachment-item" :class="{ 'is-image': isImage(attachment) }">
				<!-- Image thumbnail -->
				<div v-if="isImage(attachment)" class="image-thumbnail" @click="previewImage(attachment)">
					<img :src="getImageUrl(attachment)" :alt="attachment.name" class="thumbnail-image" />
					<div class="remove-button" @click.stop="removeAttachment(index)">
						<InlineSvg src="/images/icons-2025/x-close.svg" />
					</div>
				</div>

				<!-- File card -->
				<div v-else class="file-card">
					<div class="file-icon">
						<InlineSvg :src="getFileIcon(attachment)" />
					</div>
					<div class="file-info">
						<div class="file-name">{{ attachment.name }}</div>
						<div class="file-type">{{ getFileType(attachment) }}</div>
					</div>
					<div class="remove-button" @click="removeAttachment(index)">
						<InlineSvg src="/images/icons-2025/x-close.svg" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'FileAttachmentPreview',
		props: {
			attachments: {
				type: Array,
				default: () => [],
			},
		},
		methods: {
			isImage(file) {
				return file.type.startsWith('image/')
			},
			getImageUrl(file) {
				return URL.createObjectURL(file)
			},
			getFileIcon() {
				return '/images/icons-2025/file.svg'
			},
			getFileType(file) {
				// Extract file extension or type
				const extension = file.name
					.split('.')
					.pop()
					.toUpperCase()
				return extension || file.type.split('/')[1]?.toUpperCase() || 'FILE'
			},
			removeAttachment(index) {
				this.$emit('remove-attachment', index)
			},
			previewImage(attachment) {
				this.$emit('preview-image', attachment)
			},
		},
	}
</script>

<style lang="scss" scoped>
	.attachments-container {
		display: flex;
		gap: 8px;
		overflow-x: auto;
		padding-bottom: 4px;

		// hack to imitate no padding, lol
		padding-left: 16px;
		padding-right: 16px;
		margin-left: -16px;
		margin-right: -16px;

		&::-webkit-scrollbar {
			height: 0;
			width: 0;
		}

		&::-webkit-scrollbar-track {
			background: transparent;
		}

		&::-webkit-scrollbar-thumb {
			background: transparent;
		}

		&::-webkit-scrollbar-thumb:hover {
			background: transparent;
		}
	}

	.attachment-item {
		flex-shrink: 0;
		position: relative;

		&.is-image {
			.image-thumbnail {
				width: 64px;
				height: 64px;
				border: 1px solid #e9ecff;
				border-radius: 7.5px;
				overflow: hidden;
				position: relative;
				cursor: pointer;

				.thumbnail-image {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}

				.remove-button {
					position: absolute;
					top: 4px;
					right: 4px;
					width: 14px;
					height: 14px;
					border-radius: 50%;
					background: white;
					border: none;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					transition: background-color 0.2s ease;

					&:hover {
						background: #f3f4f6;
					}

					svg::v-deep {
						width: 12px;
						height: 12px;

						path {
							fill: #131f60;
						}
					}
				}
			}
		}

		.file-card {
			display: flex;
			align-items: center;
			gap: 8px;
			padding: 7px;
			border-radius: 10px;
			background: #ffffff;
			border: 1px solid #e9ecff;
			min-width: 200px;
			max-width: 200px;
			position: relative;

			.file-icon {
				width: 48px;
				height: 48px;
				border-radius: 7.5px;
				background: #005252;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;

				svg::v-deep {
					width: 28px;
					height: 28px;

					path {
						fill: white;
					}
				}
			}

			.file-info {
				flex: 1;
				min-width: 0;
				margin-right: 24px;

				.file-name {
					font-family: 'Inter', sans-serif;
					font-size: 14px;
					font-weight: 400;
					color: #131f60;
					line-height: 140%;
					margin-bottom: 2px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.file-type {
					font-family: 'Inter', sans-serif;
					font-size: 10px;
					font-weight: 400;
					color: #131f60;
					line-height: 140%;
					margin-bottom: 2px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}

			.remove-button {
				position: absolute;
				top: 4px;
				right: 4px;
				width: 14px;
				height: 14px;
				border-radius: 50%;
				background: #131f60;
				border: none;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				transition: background-color 0.2s ease;

				&:hover {
					background: #374151;
				}

				svg::v-deep {
					width: 12px;
					height: 12px;

					path {
						fill: #ffffff;
					}
				}
			}
		}
	}
</style>
